/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pharmacy-external-order.reducer';

export const PharmacyExternalOrder = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const pharmacyExternalOrderList = useAppSelector(state => state.pharmacyExternalOrder.entities);
  const loading = useAppSelector(state => state.pharmacyExternalOrder.loading);
  const totalItems = useAppSelector(state => state.pharmacyExternalOrder.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pharmacy-external-order-heading" data-cy="PharmacyExternalOrderHeading">
        <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.home.title">Pharmacy External Orders</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/pharmacy-external-order/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.home.createLabel">Create new Pharmacy External Order</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.pharmacyExternalOrder.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {pharmacyExternalOrderList && pharmacyExternalOrderList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('status')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.status">Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('status')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('addedById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.addedById">Added By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedById')} />
                </th>
                <th className="hand" onClick={sort('modifiedById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.modifiedById">Modified By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedById')} />
                </th>
                <th className="hand" onClick={sort('fulfilledById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.fulfilledById">Fulfilled By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('fulfilledById')} />
                </th>
                <th className="hand" onClick={sort('addedByType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.addedByType">Added By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByType')} />
                </th>
                <th className="hand" onClick={sort('modifiedByType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.modifiedByType">Modified By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByType')} />
                </th>
                <th className="hand" onClick={sort('fulfilledByType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.fulfilledByType">Fulfilled By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('fulfilledByType')} />
                </th>
                <th className="hand" onClick={sort('orderDirection')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.orderDirection">Order Direction</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('orderDirection')} />
                </th>
                <th className="hand" onClick={sort('supplierId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.supplierId">Supplier Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('supplierId')} />
                </th>
                <th className="hand" onClick={sort('supplierIdType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.supplierIdType">Supplier Id Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('supplierIdType')} />
                </th>
                <th className="hand" onClick={sort('consumerId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.consumerId">Consumer Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consumerId')} />
                </th>
                <th className="hand" onClick={sort('consumerType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.consumerType">Consumer Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consumerType')} />
                </th>
                <th className="hand" onClick={sort('createdById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.createdById">Created By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdById')} />
                </th>
                <th className="hand" onClick={sort('createdByType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.createdByType">Created By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdByType')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {pharmacyExternalOrderList.map((pharmacyExternalOrder, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pharmacy-external-order/${pharmacyExternalOrder.id}`} color="link" size="sm">
                      {pharmacyExternalOrder.id}
                    </Button>
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyIndentStatus.${pharmacyExternalOrder.status}`} />
                  </td>
                  <td>{pharmacyExternalOrder.active ? 'true' : 'false'}</td>
                  <td>{pharmacyExternalOrder.cursor}</td>
                  <td>{pharmacyExternalOrder.lastUpdated}</td>
                  <td>{pharmacyExternalOrder.microSec}</td>
                  <td>{pharmacyExternalOrder.timestampEntry}</td>
                  <td>{pharmacyExternalOrder.addedById}</td>
                  <td>{pharmacyExternalOrder.modifiedById}</td>
                  <td>{pharmacyExternalOrder.fulfilledById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyAddedByType.${pharmacyExternalOrder.addedByType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyAddedByType.${pharmacyExternalOrder.modifiedByType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyAddedByType.${pharmacyExternalOrder.fulfilledByType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyIndentType.${pharmacyExternalOrder.orderDirection}`} />
                  </td>
                  <td>{pharmacyExternalOrder.supplierId}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.SupplierType.${pharmacyExternalOrder.supplierIdType}`} />
                  </td>
                  <td>{pharmacyExternalOrder.consumerId}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ConsumerType.${pharmacyExternalOrder.consumerType}`} />
                  </td>
                  <td>{pharmacyExternalOrder.createdById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyAddedByType.${pharmacyExternalOrder.createdByType}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/pharmacy-external-order/${pharmacyExternalOrder.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pharmacy-external-order/${pharmacyExternalOrder.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pharmacy-external-order/${pharmacyExternalOrder.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.home.notFound">No Pharmacy External Orders found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={pharmacyExternalOrderList && pharmacyExternalOrderList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PharmacyExternalOrder;
